<template>
  <div>
    <b-container>
      <b-row>
        <b-col md="12" sm="12" lg="12" xs="12" xl="8" class="text-left">
          <h1>A keresett oldal csak Ügyfélkapus bejelentkezés után érhető el.</h1>
          <b-button size="lg" to="/" class="mt-5" variant="primary">Főoldal</b-button>
        </b-col>
        <b-col md="12" sm="12" lg="12" xs="12" xl="4">
          <b-img src="../assets/img/404graphics.svg" class="mt-2 mb-2 img-fluid" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.btn {
  min-width: 300px;
}
</style>
